import { AxiosResponse } from 'axios';
import { buildPath } from '../lib/url';
import { backendClient as client } from './clients';
import { ParticipantDoseExceedReadDTO } from './dto';
import { GetManyUnpaged } from './types';

export const DOSE_EXCEED_PATH = 'dose-exceed';

export const getDoseExceedInfo: GetManyUnpaged<{ activityId: number }, ParticipantDoseExceedReadDTO> = async ({
    activityId,
    config,
}) => client.get(buildPath([DOSE_EXCEED_PATH, activityId]), config).then((response: AxiosResponse) => response.data);
